import "./index.scss";
import { NavLink } from "hooks/useCustomNavigation";
import { INTERNAL_PATHS } from "routes/paths";
import { toMoneyWithTwoDecimalDigits } from "utils/currency";

export const GcxCash = ({ value }) => (
  <NavLink className="GcxCash" to={INTERNAL_PATHS.MY_RAISE_CASH}>
    {toMoneyWithTwoDecimalDigits(value)}
  </NavLink>
);
